(() => {
  'use strict';

  const rsPricePattern = /\bRs\.?\s*(?=\d)/g;
  const rsPriceTest = /\bRs\.?\s*(?=\d)/;
  const skipTags = new Set(['SCRIPT', 'STYLE', 'TEXTAREA', 'NOSCRIPT']);

  const normalizeThemeMoneyFormat = () => {
    if (window.theme && typeof window.theme.moneyFormat === 'string') {
      window.theme.moneyFormat = window.theme.moneyFormat
        .replace(/Rs\.\s*/g, '₹')
        .replace(/Rs\s+/g, '₹');
    }
  };

  const normalizeTextNode = (node) => {
    if (!node || node.nodeType !== Node.TEXT_NODE || !node.nodeValue) return;
    const parent = node.parentElement;
    if (!parent || skipTags.has(parent.tagName)) return;
    if (rsPriceTest.test(node.nodeValue)) {
      node.nodeValue = node.nodeValue.replace(rsPricePattern, '₹');
    }
  };

  const normalizePriceAttributes = (element) => {
    if (!(element instanceof Element)) return;
    ['aria-label', 'title'].forEach((attribute) => {
      const value = element.getAttribute(attribute);
      if (value && rsPriceTest.test(value)) {
        element.setAttribute(attribute, value.replace(rsPricePattern, '₹'));
      }
    });
  };

  const silenceVideo = (video) => {
    if (!(video instanceof HTMLVideoElement)) return;

    const enforceSilentVideo = () => {
      video.muted = true;
      video.defaultMuted = true;
      video.volume = 0;
      video.controls = false;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.removeAttribute('controls');
    };

    enforceSilentVideo();

    if (video.dataset.youSilentGuard !== 'true') {
      video.dataset.youSilentGuard = 'true';
      video.addEventListener('volumechange', enforceSilentVideo);
      video.addEventListener('loadedmetadata', enforceSilentVideo);
      video.addEventListener('play', enforceSilentVideo);
    }
  };

  const walk = (root) => {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      normalizeTextNode(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root !== document.body) return;

    if (root instanceof HTMLVideoElement) silenceVideo(root);

    if (root instanceof Element) {
      normalizePriceAttributes(root);
    }

    root.querySelectorAll?.('video').forEach(silenceVideo);
    root.querySelectorAll?.('[aria-label], [title]').forEach(normalizePriceAttributes);

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) normalizeTextNode(node);
  };


/* === YOU FINAL STOREFRONT CLEANUP START === */
const cleanStorefrontArtifacts = (root) => {
  const scope = root instanceof Element || root === document ? root : document;

  scope.querySelectorAll?.('.product-item').forEach((card) => {
    const title = card.querySelector('.product-item__product-title')?.textContent?.trim().toLowerCase() || '';
    const text = card.textContent?.replace(/\s+/g, ' ').trim() || '';
    if (title === "your product's name" && /(?:₹|rs\.?\s*)99\.99/i.test(text)) {
      card.remove();
    }
  });

  scope.querySelectorAll?.('h1,h2,h3,h4,h5,h6').forEach((heading) => {
    if (heading.textContent?.trim().toLowerCase() !== 'feature highlight') return;
    const container = heading.closest('section, .shopify-section, [data-section-id], .product__block');
    if (!container) return;

    const meaningfulText = (container.textContent || '')
      .replace(/feature highlight/ig, '')
      .replace(/\s+/g, ' ')
      .trim();

    const hasMeaningfulMedia = Boolean(container.querySelector('img[src], video[src], iframe[src], .product-item, a[href], button'));
    if (!meaningfulText && !hasMeaningfulMedia) {
      container.hidden = true;
    }
  });

  scope.querySelectorAll?.('.recommended-products__slider-wrapper').forEach((wrapper) => {
    if (!wrapper.querySelector('.product-item')) {
      const section = wrapper.closest('.recommended-products');
      if (section) section.hidden = true;
    }
  });
};
/* === YOU FINAL STOREFRONT CLEANUP END === */

  const start = () => {
    normalizeThemeMoneyFormat();
    walk(document.body);
    cleanStorefrontArtifacts(document);

    const observer = new MutationObserver((mutations) => {
      normalizeThemeMoneyFormat();
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          normalizeTextNode(mutation.target);
          return;
        }
        mutation.addedNodes.forEach((node) => {
          walk(node);
          if (node instanceof Element) cleanStorefrontArtifacts(node);
        });
      });
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
